import { FC, useMemo } from 'react';
import { Tabs, TabItem } from '@new/common/ui/Tabs/Tabs';
import { CourseStatus } from '@new/features/degree/types';
import { useCourseListContext } from '@new/common/contexts/CourseListContext';
import { useCan } from '@new/casl';

interface CourseStatusTabsProps {
  readOnly?: boolean;
}

export const CourseStatusTabs: FC<CourseStatusTabsProps> = ({ readOnly }) => {
  const { selectedStatus, setSelectedStatus, statusCounts } = useCourseListContext();
  const isStudent = useCan('start', 'Course', { readOnly });

  const tabs: TabItem<CourseStatus>[] = useMemo(
    () => [
      { value: 'all', label: 'All' },
      { value: 'inProgress', label: 'In Progress', count: statusCounts.inProgress },
      { value: 'completed', label: 'Completed', count: statusCounts.completed },
      { value: 'notStarted', label: 'Not Started', count: statusCounts.notStarted },
    ],
    [statusCounts]
  );

  if (!isStudent) {
    return null;
  }

  return <Tabs tabs={tabs} value={selectedStatus} onValueChange={setSelectedStatus} />;
};
